export default __webpack_public_path__ + "icon_arrow.d57fe2e1349e2d8112fbb846990a855c.svg";